import { render, staticRenderFns } from "./investRecord.vue?vue&type=template&id=6eb88db4&scoped=true"
import script from "./investRecord.vue?vue&type=script&lang=js"
export * from "./investRecord.vue?vue&type=script&lang=js"
import style0 from "./investRecord.vue?vue&type=style&index=0&id=6eb88db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb88db4",
  null
  
)

export default component.exports